import React, { Component } from 'react';
import Link from 'gatsby-link';
import classnames from 'classnames';
import Helmet from 'react-helmet';
import { parse as parseQueryString } from 'qs';
import styles from './styles.module.css';

import memoryData from '../../../data/memories.js';

import searchFilterAndSortMemories from '../../utils/search/memories';

import DropDown from '../../components/drop-down';
import BackgroundContainer from '../../components/background-container';
import SearchBox from '../../components/search-box';
import GridWrap from '../../components/grid-wrap';
import GridRow from '../../components/grid-row';
import SiteFooter from '../../components/site-footer';
import PillButton from '../../components/pill-button';
import Memory from '../../components/memory';
import ContributionForm from '../../components/contribution-form';

import RoomImage from '../../images/room.jpg';
import TileOneImage from '../../images/tile-one.jpg';
import TileTwoImage from '../../images/tile-two.jpg';

const RESULTS_PER_PAGE = 10;

const text = {
  ALL_SHOWN: 'Showing all memories',
  SHOWING_X_OF_Y_TOTAL: 'Showing {x} out of {y} total memories',
  SHOWING_X_OF_Y_RESULTS: 'Showing {x} out of {y} results',
  NONE_FOUND: 'No memories found matching your search criteria',

  ADD_MEMORY_CTA: 'Add a memory',
};

const getShownText = (filteredListLength, totalAmount) => {
  if (filteredListLength === totalAmount) {
    return text.ALL_SHOWN;
  } else if (filteredListLength === 0) {
    return text.NONE_FOUND;
  } else {
    return text.SHOWING_X_OF_Y_TOTAL
      .replace('{x}', filteredListLength)
      .replace('{y}', totalAmount);
  }
};

const getFooterShownText = (amountShown, filteredListLength) => {
  if (amountShown >= filteredListLength) {
    return text.ALL_SHOWN;
  } else {
    return text.SHOWING_X_OF_Y_RESULTS
      .replace('{x}', amountShown)
      .replace('{y}', filteredListLength);
  }
};

export default class Memories extends Component {
  constructor(props) {
    super(props);

    const query = parseQueryString(
      typeof location !== 'undefined' &&
        location.search &&
        location.search.slice(1)
    );

    const searchTerm = query.term || '';

    this.state = {
      searchTerm,
      typeFilter: '',
      sortOrder: '',
      filteredList: searchFilterAndSortMemories(memoryData, searchTerm),
      amountShown: RESULTS_PER_PAGE,

      contributingOpen: false,
    };
  }

  updateSearchTerm = event => {
    const value = event.target.value;
    this.setState(state => ({ searchTerm: value }));
  };

  updateSortOrder = event => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Search',
      eventAction: 'SortOrder',
      eventLabel: 'memoryPage',
    });
    const value = event.target.value;
    this.setState(state => ({ sortOrder: value }));
    this.performSearch();
  };

  updateTypeFilter = event => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Search',
      eventAction: 'Filter',
      eventLabel: 'memoryPage',
    });
    const value = event.target.value;
    this.setState(state => ({ typeFilter: value }));
    this.performSearch();
  };

  performSearch = () => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Search',
      eventAction: 'Submit',
      eventLabel: 'memoryPage',
    });
    this.setState(state => ({
      filteredList: searchFilterAndSortMemories(
        memoryData,
        state.searchTerm,
        state.typeFilter,
        state.sortOrder
      ),
    }));
  };

  showMoreResults = () => {
    this.setState({ amountShown: this.state.amountShown + RESULTS_PER_PAGE });
  };

  openContributing = view => this.setState({ contributingOpen: true });
  closeContributing = view => this.setState({ contributingOpen: false });

  render() {
    const { filteredList, amountShown } = this.state;

    return (
      <div className={styles.container}>
        <Helmet title="Search Whitefriars Memories" />
        <BackgroundContainer src={RoomImage}>
          <GridWrap>
            <div className={styles.header}>
              <h1>Memories</h1>
              <SearchBox
                value={this.state.searchTerm}
                onChange={this.updateSearchTerm}
                applySearchTerm={this.performSearch}
              />
              <div className={styles.options}>
                <DropDown
                  id="sort-by"
                  label="Sort by:"
                  options={[
                    { text: 'Newest First', value: 'date:desc' },
                    { text: 'Oldest First', value: 'date:asc' },
                    { text: 'Name (A - Z)', value: 'name:asc' },
                    { text: 'Name (Z - A)', value: 'name:desc' },
                  ]}
                  value={this.state.sortOrder}
                  onChange={this.updateSortOrder}
                />
                <DropDown
                  id="show-only"
                  label="Show only:"
                  options={[
                    { text: 'All memories', value: 'all' },
                    { text: 'Public', value: 'PUBLIC' },
                    { text: 'Staff', value: 'STAFF' },
                    { text: 'Collectors', value: 'COLLECTOR' },
                    { text: 'Staff Relatives', value: 'STAFF_RELATIVE' },
                  ]}
                  value={this.state.typeFilter}
                  onChange={this.updateTypeFilter}
                />
              </div>
            </div>
          </GridWrap>
        </BackgroundContainer>
        <GridWrap>
          <div className={styles.content}>
            <div className={styles.shown}>
              <span>
                {getShownText(filteredList.length, memoryData.length)}
              </span>
              <PillButton
                id="open-add-memory"
                small
                text={text.ADD_MEMORY_CTA}
                onClick={this.openContributing}
              />
            </div>

            {this.state.filteredList
              .slice(0, amountShown)
              .map(memoryDetails => (
                <Memory key={memoryDetails.submissionDate} {...memoryDetails} />
              ))}

            {filteredList.length > 0 && (
              <div className={styles.listEnd}>
                <div className={styles.progress}>
                  {getFooterShownText(amountShown, filteredList.length)}
                </div>
                {amountShown < filteredList.length && (
                  <PillButton text="Load more" onClick={this.showMoreResults} />
                )}
              </div>
            )}
          </div>
        </GridWrap>

        {this.state.contributingOpen && (
          <ContributionForm form="memory" closeForm={this.closeContributing} />
        )}

        <SiteFooter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/memories/index.js